(function(){
  'use strict';
  var cfg=window.LMP_APP_CONFIG||{};
  var qs=new URLSearchParams(location.search||'');

  function escHtml(v){
    if(typeof window.esc==='function')return window.esc(v);
    return String(v==null?'':v).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }
  function appLink(path,extra){
    if(typeof window.appUrl==='function')return window.appUrl(path,extra);
    return path+(extra?((path.indexOf('?')>-1?'&':'?')+extra):'');
  }
  function normalizeImageSafe(src){
    if(typeof window.normalizeImage==='function')return window.normalizeImage(src);
    if(!src)return'';
    if(typeof src==='object')src=src.src||src.url||'';
    src=String(src);
    return src.indexOf('//')===0?'https:'+src:src;
  }

  if(location.pathname==='/search'&&qs.get('lmp_full_search')==='1'){
    try{window.nativeRoute=false;window.__LMP_NATIVE_ROUTE=false;cfg.nativeRoute=false;}catch(e){}
    function revealStoreSearch(){
      var app=document.getElementById('lmp-native-app');
      if(app)app.remove();
      document.documentElement.classList.remove('lmp-native-route','lmp-booting');
      if(document.body){document.body.style.removeProperty('visibility');document.body.style.removeProperty('overflow');}
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',revealStoreSearch,{once:true});
    else revealStoreSearch();
    return;
  }

  window.renderSearch=function(){
    var params=new URLSearchParams(location.search);var q=params.get('q')||'';
    var content=topbar(false)+'<div class="lmp-page-head"><div class="lmp-page-head__copy"><h1 class="lmp-page-title">Recherche</h1><small>Trouvez rapidement votre produit</small></div></div>'+searchBox(q)+'<div class="lmp-search-chips"><button type="button" data-lmp-quick-search="CeraVe">CeraVe</button><button type="button" data-lmp-quick-search="La Roche Posay">La Roche-Posay</button><button type="button" data-lmp-quick-search="Solaire">Solaire</button></div>'+'<div class="lmp-search-results" id="lmp-search-results">'+(q?skeleton():'<div class="lmp-empty"><strong>Que recherchez-vous ?</strong>Produit, marque ou soin : commencez à écrire ci-dessus.</div>')+'</div>';
    shell(content);
    var input=document.querySelector('[data-lmp-search-form] input');
    if(input){var t=null;input.addEventListener('input',function(){clearTimeout(t);t=setTimeout(function(){window.runSearch(input.value)},260)})}
    document.querySelectorAll('[data-lmp-quick-search]').forEach(function(btn){btn.addEventListener('click',function(){if(input){input.value=btn.getAttribute('data-lmp-quick-search');window.runSearch(input.value)}})});
    if(q)window.runSearch(q);
  };

  window.runSearch=function(q){
    q=String(q||'').trim();var el=document.getElementById('lmp-search-results');if(!el)return;
    if(q.length<2){el.innerHTML='<div class="lmp-empty"><strong>Continuez à écrire</strong>Entrez au moins 2 caractères.</div>';return}
    el.innerHTML=skeleton();
    var url='/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=7&resources[options][unavailable_products]=last&_='+Date.now();
    fetch(url,{credentials:'same-origin',headers:{'Accept':'application/json','Cache-Control':'no-cache'}}).then(function(r){if(!r.ok)throw new Error('search');return r.json()}).then(function(data){
      var all=((((data||{}).resources||{}).results||{}).products)||[];
      if(!all.length){el.innerHTML='<div class="lmp-empty"><strong>Aucun résultat</strong>Essayez un autre nom de produit ou une marque.</div>';return}
      var hasMore=all.length>6;
      var ps=all.slice(0,6);
      var cards=ps.map(function(p){
        var src=normalizeImageSafe(p.image||p.featured_image||'');var urlp=p.url||('/products/'+p.handle);var price=p.price;var priceTxt='';
        if(price!=null){priceTxt=typeof price==='number'?formatMoney(price):escHtml(String(price))}
        return '<a class="lmp-search-result" href="'+escHtml(appLink(urlp))+'" data-lmp-link>'+(src?'<img src="'+escHtml(src)+'" alt="">':'<div></div>')+'<div><div class="lmp-search-result__vendor">'+escHtml(p.vendor||'La Maison Para')+'</div><div class="lmp-search-result__title">'+escHtml(p.title)+'</div><small>Voir le produit</small></div><div class="lmp-search-result__price">'+priceTxt+'</div></a>';
      }).join('');
      var more=hasMore?'<a class="lmp-search-more" href="/search?q='+encodeURIComponent(q)+'&type=product&lmp_full_search=1"><span>Voir tous les produits</span><b>→</b></a>':'';
      el.innerHTML='<div class="lmp-search-list">'+cards+'</div>'+more;
      if(typeof window.lmpMarkDataFresh==='function')window.lmpMarkDataFresh();
    }).catch(function(){el.innerHTML='<div class="lmp-empty"><strong>Recherche indisponible</strong>Réessayez dans quelques instants.</div>'});
  };

  function brandLogoCards(brands){
    brands=brands||[];
    return '<div class="lmp-brand-grid lmp-brand-logo-grid lmp-mega-brand-logo-grid">'+brands.map(function(b){
      return '<a class="lmp-brand lmp-brand--logo" data-lmp-mega-link href="'+escHtml(appLink(b.url))+'" aria-label="'+escHtml(b.name)+'">'+
        (b.logo?'<img class="lmp-brand__logo" src="'+escHtml(b.logo)+'" alt="'+escHtml(b.name)+'" loading="lazy" onerror="this.hidden=true;this.nextElementSibling.hidden=false">':'')+
        '<span class="lmp-brand__fallback" '+(b.logo?'hidden':'')+'>'+escHtml(b.name)+'</span></a>';
    }).join('')+'</div>';
  }

  var megaRoots=[];
  var megaPanel=null;
  var megaTrail=[];
  var COLORS=[
    {soft:'#EEF7F5',accent:'#2B7B78'},
    {soft:'#F4F0FA',accent:'#73569B'},
    {soft:'#FFF5E0',accent:'#B77A19'},
    {soft:'#EDF5FA',accent:'#4F7690'},
    {soft:'#FCEFEB',accent:'#AC6651'}
  ];
  function norm(v){
    try{return String(v||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim()}
    catch(e){return String(v||'').toLowerCase().trim()}
  }
  function readMenu(){
    try{var n=document.getElementById('lmp-mobile-menu-data');var d=n?JSON.parse(n.textContent||'[]'):[];return Array.isArray(d)?d:[]}
    catch(e){return[]}
  }
  function rootCategories(){
    return readMenu().filter(function(item){var t=norm(item.title);return t.indexOf('marque')===-1&&t.indexOf('info')===-1});
  }
  function itemAt(path){
    var parts=String(path||'').split('.').filter(Boolean),list=megaRoots,item=null;
    for(var i=0;i<parts.length;i++){
      var idx=Number(parts[i]);item=list[idx];if(!item)return null;list=Array.isArray(item.children)?item.children:[];
    }
    return item;
  }
  function varsFor(rootIndex){var c=COLORS[rootIndex%COLORS.length];return '--lmp-mega-soft:'+c.soft+';--lmp-mega-accent:'+c.accent+';'}
  function megaCard(item,path,rootIndex){
    var kids=item&&Array.isArray(item.children)?item.children:[];
    if(kids.length){
      return '<button type="button" class="lmp-mega-category-card lmp-mega-filter-item" data-lmp-category-path="'+escHtml(path)+'" data-title="'+escHtml(item.title)+'" style="'+varsFor(rootIndex)+'"><strong>'+escHtml(item.title)+'</strong><span>›</span></button>';
    }
    var href=item.url||'/';
    return '<a class="lmp-mega-category-card lmp-mega-filter-item" data-lmp-mega-link data-title="'+escHtml(item.title)+'" href="'+escHtml(appLink(href))+'" style="'+varsFor(rootIndex)+'"><strong>'+escHtml(item.title)+'</strong><span>→</span></a>';
  }
  function renderMegaHome(){
    if(!megaPanel)return;
    megaTrail=[];
    megaPanel.innerHTML='<div class="lmp-mega-category-intro"><strong>Choisissez une catégorie</strong><small>Puis affinez votre besoin</small></div><div class="lmp-mega-category-grid">'+megaRoots.map(function(item,i){return megaCard(item,String(i),i)}).join('')+'</div>';
  }
  function renderMegaLevel(path){
    if(!megaPanel)return;var item=itemAt(path);if(!item)return;
    var parts=path.split('.'),rootIndex=Number(parts[0])||0,kids=Array.isArray(item.children)?item.children:[];
    megaTrail=parts;
    var broad='';
    try{if(item.url&&new URL(item.url,location.origin).pathname!=='/')broad='<a class="lmp-mega-category-all" data-lmp-mega-link href="'+escHtml(appLink(item.url))+'" style="'+varsFor(rootIndex)+'">Voir tous les produits <span>→</span></a>'}catch(e){}
    megaPanel.innerHTML='<div class="lmp-mega-category-level" style="'+varsFor(rootIndex)+'"><button type="button" class="lmp-mega-category-back" data-lmp-category-back>‹ Retour</button><div class="lmp-mega-category-title"><small>Catégorie</small><h2>'+escHtml(item.title)+'</h2></div>'+broad+'</div><div class="lmp-mega-category-grid lmp-mega-category-grid--children">'+kids.map(function(child,i){return megaCard(child,path+'.'+i,rootIndex)}).join('')+'</div>';
  }
  function upgradeMegaBrands(sheet){
    var panel=sheet&&sheet.querySelector('[data-lmp-mega-panel="marques"]');
    if(!panel)return;
    var brands=cfg.appBrands||[];
    if(!brands.length)return;
    panel.innerHTML=brandLogoCards(brands);
  }
  function upgradeMega(){
    var sheet=document.querySelector('#lmp-native-app .lmp-mega-sheet');
    if(!sheet)return;
    upgradeMegaBrands(sheet);
    megaPanel=sheet.querySelector('[data-lmp-mega-panel="categories"]');
    if(!megaPanel)return;
    megaRoots=rootCategories();
    if(!megaRoots.length)return;
    if(megaPanel.getAttribute('data-lmp-compact-ready')==='1')return;
    megaPanel.setAttribute('data-lmp-compact-ready','1');
    renderMegaHome();
    megaPanel.addEventListener('click',function(e){
      var open=e.target.closest('[data-lmp-category-path]');
      if(open){e.preventDefault();e.stopPropagation();renderMegaLevel(open.getAttribute('data-lmp-category-path'));return}
      var back=e.target.closest('[data-lmp-category-back]');
      if(back){e.preventDefault();e.stopPropagation();if(megaTrail.length<=1){renderMegaHome();return}var p=megaTrail.slice(0,-1).join('.');renderMegaLevel(p)}
    });
  }

  document.addEventListener('click',function(e){
    var nav=e.target&&e.target.closest?e.target.closest('#lmp-native-app .lmp-native-nav a'):null;
    var tab=e.target&&e.target.closest?e.target.closest('[data-lmp-mega-tab="categories"],[data-lmp-mega-tab="marques"]'):null;
    if(nav){try{if(new URL(nav.href,location.href).pathname==='/pages/categories-parapharmacie')requestAnimationFrame(function(){setTimeout(upgradeMega,0)})}catch(x){}}
    if(tab)requestAnimationFrame(function(){setTimeout(upgradeMega,0)});
  },true);

  function initEnhancements(){
    upgradeMega();
    if(window.MutationObserver&&(cfg.standalone||cfg.previewMode)){
      new MutationObserver(function(mutations){
        var needsMega=false;
        mutations.forEach(function(m){
          Array.prototype.forEach.call(m.addedNodes||[],function(n){
            if(n.nodeType!==1)return;
            if((n.matches&&n.matches('.lmp-mega-sheet'))||(n.querySelector&&n.querySelector('.lmp-mega-sheet')))needsMega=true;
          });
        });
        if(needsMega)requestAnimationFrame(function(){setTimeout(upgradeMega,0)});
      }).observe(document.documentElement,{childList:true,subtree:true});
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initEnhancements,{once:true});
  else initEnhancements();
})();
